import api from './api';

export interface Estabelecimento {
  id: string;
  nome: string;
  codigo?: number;
}

export const getAllEstabelecimentos = () => api.get<Estabelecimento[]>('estabelecimentos');

export const getEstabelecimentosOptions = () =>
getAllEstabelecimentos().then(estabelecimentos =>
    (estabelecimentos || []).map(item => ({ text: item.nome, value: item.id.toString() })),
  );
